export const tituloInfo1 = 'Investimento e Funcionamento da Terapia'; // INVESTIMENTO NO SEU PROCESSO TERAPÊUTICO
// export const tituloInfo2 = 'Reembolso Convênio';
export const tituloInfo2 = 'Formas de Pagamento';
export const tituloInfo3 = 'Plano de Saúde e Convênio';
export const tituloInfo4 = 'Terapia On-line';
export const tituloInfo5 = 'Frequência e Duração do Processo';
export const tituloInfo6 = 'Agendamento';